const CardBase = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="text-tBase hover:bg-tertiary bg-secondary group relative flex flex-col overflow-hidden rounded-3xl transition-colors lg:rounded-[32px]">
      {children}
    </div>
  );
};

export default CardBase;
